import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { AuthService } from 'src/app/_services/auth.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Routes } from 'src/app/_config/routes.config';
import { StorageService } from 'src/app/_services/storage.service';
import { Subscription } from 'rxjs';
import { LanguageService } from 'src/app/_services/language.service';
import { LanguageMessage } from 'src/app/_models/language-message.model.';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'DCO-end-enrollment',
  templateUrl: './end-enrollment.component.html',
  standalone: false,
})
export class EndEnrollmentComponent extends BaseComponent implements OnInit {
  // Variables necesarias para el Header y la navegación
  username: string | null = null;
  menuAbierto = false;
  showInfoEnrollment = false;
  ContactGroupId: any;
  
  private userSubscription$!: Subscription;
  private languagesDownloaded$!: Subscription;
  languages = [];
  private languageChanged$!: Subscription;
  public selectedLanguage = '';
  languageMessage: LanguageMessage;
  htmlMessage: SafeHtml;

  constructor(
    public override router: Router,
    public override langService: LanguageManagerService,
    public _translationService: LanguageManagerService,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private storageService: StorageService,
    private sanitizer: DomSanitizer,
  ) {
    super(router, _translationService, route);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    
    
    this.route.queryParams.subscribe((params) => {
      this.ContactGroupId = params['contactGroupId'];
    });

this.languagesDownloaded$ =
      this.langService.languagesDownloaded$.subscribe((languages) => {
        // cuando termina de cargar los idiomas mostramos el desplegable
        // console.log('enrollment languages',languages)
        this.languages = languages;
      });
    this.languageChanged$ = this.langService.languageChanged$.subscribe(
      (selectedLanguage) => {
        // console.log('enrollment selectedLanguage',selectedLanguage)
        // cuando recibimos el evento de cambiar de idioma cambiamos la seleccion del desplegable
        // eso ocurre al cargar la pagina, el desplegable puede poner el primer valor
        // pero podemos tener guardado un idioma determinado seleccionado
        this.selectedLanguage = selectedLanguage;
      }
    );

    // Suscripción para obtener el nombre del usuario
    this.userSubscription$ = this.storageService.userInfo.subscribe((user) => {
      this.username = user ? user.user : null;
    });

    // Cargar idiomas disponibles
    this.langService.languagesDownloaded$.subscribe((langs) => {
      this.languages = langs;
    });

    // Sincronizar idioma seleccionado
    this.langService.languageChanged$.subscribe((lang) => {
      this.selectedLanguage = lang;
      this.getLanguageMessage();
    });
    
  }

  renderizarHtml(htmlCrudo: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlCrudo);
  }

  getLanguageMessage() {
    let key = 'DCO.DCLAIMS_CONTACT_HELP_VIDEO';
    this.languageService.getLanguageMessage(key, this.selectedLanguage).subscribe({
      next: (response) => {
        this.languageMessage = response;

        let mensaje = this.languageMessage.message;
        mensaje = mensaje.replace(/(\r\n|\n|\r)/gm, "");

        this.htmlMessage = this.sanitizer.bypassSecurityTrustHtml(mensaje);
      }
    });
  }

  async GoDisputes(): Promise<void> {
      this.router.navigate([Routes.DEFAULT]);
  }

  GoBack() {
    let contactGroupId = this.ContactGroupId;
    this.router.navigate(['/document-details'], {
      queryParams: { contactGroupId },
    });
  }

  SetLanguage(lang: any) {
    this._translationService.SetLanguage(lang);
    this.getLanguageMessage();
  }

  logOut() {
    this.authService.logOut();
    this.router.navigate([Routes.LOGIN]);
  }

  VerVideo(event: Event) {
  const boton = (event.target as HTMLElement).closest('#btn-ver-tutorial') as HTMLButtonElement;
  
  if (boton) {
    const videoUrl = boton.getAttribute('data-video-url');
    if (videoUrl) {
      window.open(videoUrl, '_blank');
    }
  }
}
}
